export default "__VITE_ASSET__786DyBKA__"